<script setup lang="ts">

import {Alert, AlertDescription, AlertTitle, type AlertVariants} from "@/shared/components/ui/alert";
import type {HTMLAttributes} from "vue";
import {Validation} from "@/shared/graphql/types";
//@ts-ignore
import {cn} from "@/shared/lib/utils.ts";
import {useI18n} from "vue-i18n";
const {t} = useI18n()

const props = withDefaults(defineProps<{
  title?:string,
  validation: Validation
  class?: HTMLAttributes['class']
  variant?: AlertVariants['variant']
}>(), {})

const _title = props.title || t('shared.validation_alert.save_error');

</script>

<template>
  <Alert  variant="negative" :class="cn(props.class)" id="errorMessage" >
    <AlertTitle>{{ _title }}</AlertTitle>
    <AlertDescription v-if="validation.globalErrors.length > 0">
      <ul class="mt-1.5 list-disc list-inside">
        <li v-for="error in validation.globalErrors">{{error.message}}</li>
      </ul>
    </AlertDescription>
  </Alert>
</template>

<style scoped>

</style>